<app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage"
  [purchaseType]="statusData.purchaseType" [clickHandler]="returnToWorkList" [approvalOfficerData]="currentWorkflow">
</app-bread-crumbs>

<div class="page-container">
  <div *ngIf="isNotExcoBoard && actionTaken?.status" class="mt-2 mb-4 alert-padding">
    <shared-alert [type]="alertType.Info">
      <div alert-content class="my-1">
        <ng-container *ngIf="actionTaken?.status === 'pending'">
          <span>Please review the <span class="highlight">
              {{messagePieces.pending.first}}
            </span> <span *ngIf="messagePieces.pending.second">for the <span
                class="highlight">{{messagePieces.pending.second}}</span></span>
            <span> {{messagePieces.pending.third}}</span>.</span>
        </ng-container>
        <ng-container *ngIf="actionTaken?.status === 'taken'">
          <span>You have <span class="highlight">{{messagePieces.taken.first}}</span> the <span
              *ngIf="messagePieces.taken.second" class="highlight">{{messagePieces.taken.second}}</span>
            <span> {{messagePieces.taken.third}}</span>
            .</span>
        </ng-container>
      </div>
    </shared-alert>
  </div>

  <div *ngIf="excoBoardMessage" class="mt-2 mb-4">
    <shared-alert [type]="alertType.Info">
      <p alert-content class="my-1"><span [innerHTML]="excoBoardMessage"></span></p>
    </shared-alert>
  </div>
  <app-layout class="container--form">
    <div class="status">
      <mat-grid-list cols="3" rowHeight="25px">
        <mat-grid-tile>
            <mat-card-content class="tile-content-doc">
              <span class="status-key paragraph-medium-regular">Document No:</span>
              <span class="status-value-doc link paragraph-medium-bold" 
                (keypress)="navigateToRO(statusData.documentNo,statusData.purchaseType)"
                (click)="navigateToRO(statusData.documentNo,statusData.purchaseType)">{{statusData.documentNo}}
              </span>
            </mat-card-content>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card-content class="tile-content"><span class="status-key paragraph-medium-regular">Requesting Officer:</span>
            <span class="status-value paragraph-medium-bold">{{
              statusData.requestingOfficer
              }}</span>
          </mat-card-content>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card-content class="tile-content"><span class="status-key paragraph-medium-regular">Submitted on:</span>
            <span class="status-value paragraph-medium-bold">{{
              statusData.submittedOn | date: 'dd/MM/yyyy'
              }}</span>
          </mat-card-content>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card-content class="tile-content"><span class="status-key paragraph-medium-regular">Document Status:</span><span
              class="status-value paragraph-medium-bold">{{
              statusData.status
              }}</span></mat-card-content></mat-grid-tile>
        <mat-grid-tile>
          <mat-card-content class="tile-content"><span class="status-key paragraph-medium-regular">Workflow Status:</span>
            <span class="status-value paragraph-medium-bold">{{
              statusData.subStatus
              }}</span>
          </mat-card-content>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    <mat-tab-group dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Overview">
        <div class="app-worklists">
          <app-loader [isLoading]="isApprovingOverviewLoading"></app-loader>
          <app-approving-overview *ngIf="!isApprovingOverviewLoading" [ApprovingOfficerSummary]="approvingOfficerSummary"
            [currentWorkflow]="currentWorkflow" [mpDocumentDraftDetails]="mpDocumentDraftDetails"></app-approving-overview>
        </div>
      </mat-tab>
      <mat-tab label="Current workflow">
        <div class="app-worklists">
          <app-current-workflow [MpNumber]="currentPageString"
            (userAction)="getUserAction($event)"></app-current-workflow>
        </div>
      </mat-tab>
    </mat-tab-group>
  </app-layout>
</div>